
























































import { Component, Vue } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue'
import { WorkerAnonModule } from '@/store/modules/workerAnon';
import { AppModule } from '@/store/modules/app';
import JobInviteInterestedNotInterested from '@/components/AnonWorkers/JobInviteInterestedNotInterested.vue';
import { VuetifyConfirmObject } from "vuetify-confirm";
import UpdateAnonWorkerBookingOfferRequest from '@/models/AnonBookingRoleWorkers/UpdateAnonWorkerBookingOfferRequest';
import AnonJobWorkerInviteDto from '@/models/AnonJobWorkers/AnonJobWorkerInviteDto';

@Component({
  name: 'JobInvite',
  components: { JobInviteInterestedNotInterested }
})
export default class JobInvite extends GiganautVue {

  get jobInvite(): AnonJobWorkerInviteDto {
    return WorkerAnonModule.jobInvite;
  }

  get loading() {
    return WorkerAnonModule.loading;
  }

  get agency() {
      return AppModule.currentAgencyContext;
  }

  get isInviteSubmitted() {
      return WorkerAnonModule.isJobInviteSubmitted;
  }
}
